<div ngbDropdown>
  <hub-button
    type="clean"
    class="notification-dropdown-btn hub-fs-14"
    customClass="hub-p-0"
    ngbDropdownToggle
    icon="icon-notifications">
    @if (amountOfUnreadNotifications > 0) {
      <span class="badge text-bg-danger hub-rounded-pill notification-badge">
        {{ amountOfUnreadNotifications }}
      </span>
    }
  </hub-button>

  <div
    ngbDropdownMenu
    aria-labelledby="notification-dropdown-btn"
    class="notification-dropdown-menu">
    <div class="hub-p-1-5 hub-d-flex hub-flex-column">
      <div class="hub-mb-1 hub-d-flex hub-align-items-center hub-justify-content-between">
        <p class="hub-fw-bold hub-mb-0 hub-fs-18">Notifications</p>
        <hub-button
          [isDisabled]="
            amountOfUnreadNotifications === 0 || isProgressMarkAllAsRead || !!isProgressMarkOneId
          "
          [isLoading]="isProgressMarkAllAsRead"
          class="hub-ml-auto"
          icon="icon-check"
          type="textPrimary"
          (clicked)="markAllAsRead()"
          >Mark all as read
        </hub-button>
      </div>
    </div>
    <div class="hub-d-flex hub-flex-column">
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="showUnread"
        class="nav-tabs"
        (activeIdChange)="updateNotificationsToShow()">
        <li [ngbNavItem]="false">
          <a class="tab-link hub-text-center" ngbNavLink>All</a>
          <ng-template ngbNavContent>
            <ng-container *ngTemplateOutlet="notificationsList" />
          </ng-template>
        </li>
        <li [ngbNavItem]="true">
          <a class="tab-link hub-text-center" ngbNavLink>Unread</a>
          <ng-template ngbNavContent>
            <ng-container *ngTemplateOutlet="notificationsList" />
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="hub-mt-0-5"></div>
    </div>
  </div>
</div>

<ng-template #notificationsList>
  <div class="hub-d-flex hub-flex-column notification-list-wrapper">
    @for (notification of notificationsToShow; track notification.id; let isLast = $last) {
      <hub-button
        type="clean"
        class="hub-mx-1-5 hub-py-1-5"
        customClass="hub-w-100 hub-p-0"
        [class.border-bottom]="!isLast"
        [isLoading]="isProgressMarkOneId === notification.id"
        [isDisabled]="isProgressMarkAllAsRead || isProgressMarkOneId === notification.id"
        (click)="onNotificationClick(notification)">
        <div class="hub-d-flex hub-align-items-center hub-justify-content-between">
          <p
            class="hub-fs-16 hub-fw-bold hub-mb-0 hub-text-left hub-white-space-break-spaces hub-overflow-wrap-break-word">
            {{ notification.title }}
          </p>

          @if (notification.status === notificationStatus.UNREAD) {
            <div class="unread-circle hub-bg-primary hub-rounded-circle"></div>
          }
        </div>

        <p
          class="text-start hub-fs-14 hub-mb-0-5 hub-white-space-break-spaces hub-overflow-wrap-break-word"
          [innerHTML]="notification.message"></p>
        <p class="text-start hub-fs-12 hub-mb-0 hub-text-message">
          {{ timeAgo(notification.createdAt) }}
        </p>
      </hub-button>
    } @empty {
      <p class="hub-p-1-5 hub-mb-0">There are no new notifications ATM.</p>
    }
  </div>
</ng-template>
